export default {
  purchase_orders: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  step:[],
  selected_purchase_orders : {},
  purchase_orders_status:[]
}
